import {memo} from 'react'
import TextWithIllustration from '~/components/content/TextWithIllustration'
import ProductCollection from '~/components/content/ProductCollection'
import CollectionLink from '~/components/content/CollectionLink'
import TextCard from '~/components/content/TextCard'
import Columns from '~/components/content/Columns'
import {HOME_PAGE_QUERYResult} from 'sanity.types'
import Slider from '~/components/content/Slider'

type HomePageContentProps = {
    elements: NonNullable<NonNullable<HOME_PAGE_QUERYResult>['elements']>
}

const HomePageContent = memo(({elements}: HomePageContentProps) => {
    if (elements.length === 0) {
        return null
    }

    return elements.map((element) => {
        switch (element._type) {
            case 'slider':
                return <Slider key={element._key} {...element} />
            case 'products':
                return (
                    <ProductCollection
                        key={element._key}
                        {...element}
                        className="first:mt-6 lg:first:mt-12"
                    />
                )
            case 'textWithIllustration':
                return (
                    <TextWithIllustration
                        key={element._key}
                        {...element}
                        className="first:mt-6 lg:first:mt-12"
                    />
                )
            case 'collectionLink':
                const {ref, ...propsWithoutRef} = element
                return (
                    <CollectionLink
                        key={element._key}
                        {...propsWithoutRef}
                        className="first:mt-6 lg:first:mt-12"
                    />
                )
            case 'columns':
                return (
                    <Columns
                        key={element._key}
                        {...element}
                        className="first:mt-6 lg:first:mt-12"
                    />
                )
            case 'textCard':
                return (
                    <TextCard
                        key={element._key}
                        {...element}
                        className="first:mt-6 lg:first:mt-12"
                    />
                )
            default:
                return null
        }
    })
})

export default HomePageContent
